import React, { useMemo } from "react";

import { useIntl } from "react-intl";

import { objectKeys } from "Libs/utils";

import { ApplicationListType, ApplicationType } from "../type";

import ServiceItem from "./item";
import * as S from "./style";

import type { ReturnAddClass } from "Reducers/environment/deployment";

type ServiceListProps = {
  serviceList: {
    app: ReturnAddClass[string][];
    worker: ReturnAddClass[string][];
    service: ReturnAddClass[string][];
  };
  apps?: ApplicationListType;
  onViewApp: (application?: ApplicationType) => void;
};

const ServiceList = (props: ServiceListProps) => {
  const intl = useIntl();

  const { serviceList, apps, onViewApp } = props;
  const profilableApps = useMemo(() => Object.keys(apps || {}), [apps]);

  const serviceNames = objectKeys(serviceList).filter(s => s !== "service");

  return (
    <>
      {serviceNames.map(names => {
        const service = serviceList[names];
        return service.length ? (
          <div key={names}>
            <S.CategoryName>
              {intl.formatMessage({
                id: names,
                defaultMessage: names
              })}
            </S.CategoryName>
            <S.ItemsWrapper>
              {service.map((item, i) => (
                <ServiceItem
                  onViewApp={() => {
                    onViewApp(
                      apps?.[item.name] || {
                        name: item.name
                      }
                    );
                  }}
                  isInstrumented={profilableApps.includes(item.name)}
                  key={i}
                  service={item}
                />
              ))}
            </S.ItemsWrapper>
          </div>
        ) : null;
      })}
    </>
  );
};
export default ServiceList;
